export const ruleParameterOperators = {
  greaterOrEqual: ">=",
  lessOrEqual: "<="
};
